import React, { useState } from 'react';
import { emitJson } from '../websocket/websocketSlice';
import Timer from './Timer';
import './SchoolGong.css'; // style in seperate file

const SchoolGong = () => {

    const playChime = () => {
        emitJson("playSound", { sound: "chime" });
    };

    return (
        <div className="school-gong">
            <div className="school-gong-header">
                <h6>School Gong</h6>
            </div>
            <div className="school-gong-controls">
                <span className="play-gong-label" style={{ marginBottom:"5px" }}>Play Gong:</span>
                    <button
                        className="play-gong"
                        onClick={playChime}
                        aria-label="Play Gong"
                        marginBottom="5px"
                    >
                        {"\u266A"}
                    </button>
                </div>
            <Timer onTimerExpired={playChime} />
        </div>
    );
};

export default SchoolGong;
